// extracted by mini-css-extract-plugin
export default {"logo__wrapper":"Logo_logo__wrapper__D-kmi","logo":"Logo_logo__jSHRK","modal__center":"Logo_modal__center__4-Gl6"};